import React from 'react'
import styles from './styles.module.css'

interface SeparatorProps {
  fullWidth?: boolean
  hidden?: boolean
}

const Separator = React.forwardRef<HTMLDivElement, SeparatorProps>(
  ({ fullWidth = false, hidden = false }) => {
    if (hidden) return null

    return (
      <div className={styles.separatorWrapper} data-testid="separator">
        <div className={fullWidth ? styles.fullWidth : styles.sectionWidth}>
          <div className={styles.separator} />
        </div>
      </div>
    )
  }
)

export default Separator
